<template>
    <div class="review-page">
        <div class="review-page--content">
            <div class="text-center" v-if="loading">
                <b-spinner variant="primary" />
            </div>
            <b-container v-else>
                <b-row>
                    <b-col cols="12">
                        <review
                            v-if="quote.services"
                            :request_id="this.request_id"
                            :secret="this.secret"
                        />
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import Review from '@/components/review/review' 
    import { get_review } from '@/api'
    import {custom_event} from '@/utilities'

    export default {
        name: 'review-page',
        components: {
            'review': Review,
        },
        props:{
          request_id: String,
          secret: String,
          noTrack: {
            type: Boolean,
            default: false,
          },
        },
        data() {
            return {
                loading: true,
                quote: {},
                request: {},
                quote_cover: '',
            }
        },
        computed: {
        },
        created()
        {
        },
        mounted() {
            this.log('[review.vue] - mounted()')
            let payload = {
                request_id: this.request_id,
                secret: this.secret,
                noTrack: this.noTrack,
            }
            get_review(payload)
                .then((response) => {
                    this.quote = response.quote
                    this.request = response.request
                    if(this.quote.details.coverUrl)
                    {
                        this.quote_cover = this.quote.details.coverUrl
                    }
                    else
                    {
                        this.quote_cover = 'https://staging.vadobay.com/assets/sliderHome/1-welfare-aziendale.jpeg'
                    }
                    this.$store.commit('set_quote', { quote: this.quote })
                    this.$store.commit('set_request', { request: this.request })
                    this.loading = false

                    if(!this.noTrack) custom_event('reviewOpened', this.request_id)
                })
        },
        methods:{
        },
    }
</script>

<style lang="scss">
.review-page
{
    .custom-radio
    {
        visibility:hidden !important;
    }

    &--content
    {
        margin-top:140px;
        @include media-breakpoint-up(md)
        {
            margin-top:240px
        }
    }

    &--hero
    {

    }

    &--alert
    {
        margin-bottom:20px;
        @include media-breakpoint-up(md)
        {
            margin-bottom:40px;
        }
    }
}
</style>